/* ============================================================
   D&V Market — Puente con el formulario de EasySell COD
   Nuestros botones de compra (.js-buy) abren el formulario de EasySell
   activando el botón PROPIO de EasySell (#es-popup-button / #es-sticky),
   que la app inserta en la página y que siempre abre su ventana.
   Ese botón propio se oculta con CSS (dv-form.css); se activa por código.

   Nuestros botones NO llevan la clase "es-popup-button-overwrite": con ella
   EasySell también reaccionaba al clic y cerraba el formulario recién abierto.
   El clic se escucha en window, en fase de captura.

   Respaldo: si EasySell no está cargado (app sin instalar o con su
   app embed apagado), el botón lleva al checkout de Shopify con el producto.
   ============================================================ */
(function () {
  'use strict';

  // Por si la página quedó en caché con la clase vieja en los botones
  function limpiarClase() {
    Array.prototype.forEach.call(document.querySelectorAll('.js-buy.es-popup-button-overwrite'), function (b) {
      b.classList.remove('es-popup-button-overwrite');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', limpiarClase); else limpiarClase();

  function easySellCargado() {
    var scripts = document.querySelectorAll('script[src]');
    for (var i = 0; i < scripts.length; i++) {
      if (/easysell|tyslo|easy-order-form/i.test(scripts[i].src)) return true;
    }
    return !!(window.EasySell || window.easysell || document.getElementById('easysell'));
  }

  function botonPropio() {
    return document.getElementById('es-popup-button') ||
           document.getElementById('es-sticky') ||
           document.querySelector('.es-popup-button:not(.js-buy)');
  }

  window.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.js-buy');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (btn.getAttribute('aria-disabled') === 'true') return;

    var propio = botonPropio();
    // fuera del evento actual, para que EasySell lo procese como un clic nuevo
    if (propio) { setTimeout(function () { propio.click(); }, 0); return; }

    if (easySellCargado()) {
      // EasySell todavía está armando su botón: reintenta un momento después
      setTimeout(function () { var p = botonPropio(); if (p) p.click(); }, 600);
      return;
    }
    var variante = btn.getAttribute('data-variant-id');
    if (!variante) return;
    btn.setAttribute('aria-busy', 'true');
    window.location.href = '/cart/' + variante + ':1';
  }, true);
})();
